import type { RoleId } from '@ringmaster/shared';

/**
 * Blood Moon: One Night's role list — the game's ORDER OF PLAY, plus the one
 * ordering fact worth printing. Copy only: the rules live in the engine, and
 * nothing here is read by any adjudication path.
 *
 * WHAT EACH CARD DOES IS NOT HERE. It used to be (a `text` line per role, shown
 * as a reference list under the role gallery), but every card already prints its
 * own description from ui/roleCardDefs.ts, so the list was a SECOND set of role
 * descriptions free to drift from the first. It was cut 2026-07-31 and this file
 * kept only what the cards do not say. Add role copy to ONE_NIGHT_ROLE_CARD_DEFS,
 * never here.
 *
 * The `order` line is deliberately about when a role's effect SETTLES, and it
 * exists ONLY for the two swappers. Every night role wakes in the same beat, so a
 * "wakes with everyone" / "sleeps" chip on the others said nothing a player could
 * act on and read as an ordering rule that isn't one (playtest: confusing). The
 * two swaps DO have an order — the engine applies them in the canonical ONUW card
 * order, Thief then Joker — and that is worth a chip because it changes how you
 * read a claim. See ONE_NIGHT_SPEC.md §4a.
 */
export interface OneNightRoleGuideEntry {
  role: RoleId;
  /**
   * When this card's night business settles, in table language. Present ONLY for
   * a role whose ordering is real and actionable (the two swappers).
   */
  order?: string;
}

/**
 * Listed in night-business order — the two roles that only look, then the two
 * that swap, then the role with no night at all. This is the list ROLE_PLAY_ORDER
 * reads for One Night, so it decides the order of the cards on every surface.
 */
export const ONE_NIGHT_ROLE_GUIDE: readonly OneNightRoleGuideEntry[] = [
  { role: 'WEREWOLF' },
  { role: 'SEER' },
  { role: 'THIEF', order: 'Swap settles 1st' },
  { role: 'JOKER', order: 'Swap settles 2nd' },
  { role: 'VILLAGER' },
];
